import { useLayoutEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';

const PopupPortal = ({ mount, children }) => {
  const el = useMemo(() => {
    if (typeof document === 'undefined') {
      return null;
    }

    const node = document.createElement('div');
    // Keep this node layout-neutral so it does not affect popup positioning.
    node.style.display = 'contents';
    return node;
  }, []);

  useLayoutEffect(() => {
    if (!mount || !el) {
      return undefined;
    }

    mount.appendChild(el);

    return () => {
      if (mount.contains(el)) {
        mount.removeChild(el);
      }
    };
  }, [el, mount]);

  if (!el) {
    return null;
  }

  return createPortal(children, el);
};

export default PopupPortal;
